module.exports = __webpack_public_path__ + "47bdacc78bd207edaab3aa64de4563f7.png";